import { api } from "@/services/api";
import {
  AddCommentResponseModel,
  PostCommentModel,
  PostModel,
} from "@/types/post";

const postCommentApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPostComments: build.mutation<PostCommentModel[], any>({
      query: (payload) => {
        return {
          url: "api/Comment/GetPostComments",
          method: "post",
          data: payload,
        };
      },
    }),
    addEditComment: build.mutation<AddCommentResponseModel, any>({
      query: (payload) => {
        return {
          url: "api/Comment/AddUpdateComment",
          method: "post",
          data: payload,
        };
      },
    }),
    deleteComment: build.mutation<number, any>({
      query: (payload) => {
        return {
          url: "api/Comment/DeleteComment",
          method: "post",
          data: payload,
        };
      },
    }),
    likeDislikeComment: build.mutation<PostCommentModel[], any>({
      query: (payload) => {
        return {
          url: "api/Comment/LikeDislikeComment",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPostCommentsMutation,
  useAddEditCommentMutation,
  useDeleteCommentMutation,
  useLikeDislikeCommentMutation,
} = postCommentApi;

export default postCommentApi;
